import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuGroupGetService } from '../../services';

export const fetchMenuGroupGet = createAsyncThunk(
    'menuGroupGet/fetchMenuGroupGet',
    async ({ id }) => {
        const response = await MenuGroupGetService(id)
        return response.result;
    }
);

const menuGroupGetSlice = createSlice({
    name: 'menuGroupGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGroupGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuGroupGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuGroupGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuGroupGetSlice.reducer;
